module.exports = __webpack_public_path__ + "img/genetic-cor.c81a6029.png";